import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'rad-spinner',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'aria-hidden': 'true',
        '[style.font-size]': "'var(--rad-icon-' + size() + ')'",
    },
    template: `<span class="ring"></span>`,
    styles: `
        :host {
            display: inline-flex;
        }
        .ring {
            width: 1em;
            height: 1em;
            border-radius: 50%;
            border: 0.14em solid color-mix(in srgb, currentColor 30%, transparent);
            border-top-color: currentColor;
            animation: rad-spin var(--rad-motion-spin) linear infinite;
        }
        @keyframes rad-spin {
            to {
                transform: rotate(360deg);
            }
        }
    `,
})
export class RadSpinnerComponent {

    /**
     * The spinner size, from the `--rad-icon-*` scale so it lines up with icons and text:
     * `inline` rides a line of text, `md` is a control, `lg` and `xl` are a feature slot.
     */
    readonly size = input<'inline' | 'md' | 'lg' | 'xl'>('md');
}
